import React from 'react';
import PropTypes from 'prop-types';

const WorldChampionships = props => {

    const { championships } = props;
    
    return (
        <article className="my-3 text-center">
            <ul className="px-0">
                {
                    championships.map((wchampionship, i) => 
                        <li key={i} className="list-text-team">{wchampionship}</li>
                    )                    
                }                
            </ul>
        </article>
    )
}

export default WorldChampionships;

WorldChampionships.propTypes = {
    championships: PropTypes.array.isRequired
}
